import React from 'react'
import { LanguageProvider } from './context/LanguageContext';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ChallengeSection from "./components/ChallengeSection";
import ProgrammeSection from "./components/ProgrammeSection";
import ServicesSection from "./components/ServicesSection";
import FacilitiesSection from "./components/FacilitiesSection";
import DoctorsSection from "./components/DoctorsSection";
import ProceduresSection from "./components/ProceduresSection";
import ClinicsSection from "./components/ClinicsSection";
import ContactSection from "./components/ContactSection";
import RegisterSection from "./components/RegisterSection";
import VideoSection from "./components/VideoSection";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import FloatingAppointmentButton from "./components/FloatingAppointmentButton";
import Gallery from "./components/Gallery";
import Esg from "./components/ESG/LapsleeveGastrectomy";

import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";

import Endoscopic from "./components/ESG/Endoscopic";
import GastricBalloon from './components/ESG/GastricBalloon';
import GastricBypass from './components/ESG/GastricBypass';
import LapsleeveGastrectomy from './components/ESG/LapsleeveGastrectomy';
import MiniGastricBypass from './components/ESG/MiniGastricBypass';

// Programme detail pages
import PersonalizedCarePlans from './components/personalized/PersonalizedCarePlans';
import AdvancedDiagnostics from './components/personalized/AdvancedDiagnostics';
import ExpertMedicalTeam from './components/personalized/ExpertMedicalTeam';
import LongTermSupport from './components/personalized/LongTermSupport';

const Layout = () => {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App" data-testid="app-container">
          <Toaster position="top-center" richColors />
          <Header />

          <main>
            <React.Suspense
              fallback={
                <div className="min-h-screen flex items-center justify-center bg-white">
                  <div className="w-10 h-10 border-4 border-[#800000] border-t-transparent rounded-full animate-spin"></div>
                </div>
              }
            >
              <Routes>
                {/* Home page */}
                <Route
                  path="/"
                  element={
                    <>
                      <HeroSection />
                      <ChallengeSection />
                      <ProgrammeSection />
                      <ServicesSection />
                      <FacilitiesSection />
                      <DoctorsSection />
                      <Gallery />
                      <ProceduresSection />
                      <VideoSection />
                      {/* <ClinicsSection /> */}
                      {/* <ContactSection /> */}
                    </>
                  }
                />

                {/* Endoscopic / ESG page */}
                <Route path="/esg" element={<Esg />} />

                {/* Optional: Endoscopic component */}

                <Route path="/programme" element={<ProgrammeSection />} />
                <Route path="/programme/personalized-care-plans" element={<PersonalizedCarePlans />} />
                <Route path="/programme/advanced-diagnostics" element={<AdvancedDiagnostics />} />
                <Route path="/programme/expert-medical-team" element={<ExpertMedicalTeam />} />
                <Route path="/programme/long-term-support" element={<LongTermSupport />} />
                <Route path="/services" element={<ServicesSection />} />
                <Route path="/facilities" element={<FacilitiesSection />} />
                <Route path="/expert" element={<DoctorsSection />} />
                <Route path="/procedures" element={<ProceduresSection />} />

                <Route path="/endoscopic" element={<Endoscopic />} />
                <Route path='/gastric-balloon' element={<GastricBalloon />} />
                <Route path='/gastric-bypass' element={<GastricBypass />} />
                <Route path='/lapsleeve-gastrectomy' element={<LapsleeveGastrectomy />} />
                <Route path='/miniGastricBypass' element={<MiniGastricBypass />} />

                <Route path="/contact" element={<ContactSection />} />
                <Route path="/register" element={<RegisterSection />} />
              </Routes>
            </React.Suspense>
          </main>

          <Footer />
          <FloatingAppointmentButton />
          <WhatsAppButton />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
};

export default Layout